import { LOCALES } from 'i18n/locales';

export const selectFeaturePanelIntl = {
    [LOCALES.ENGLISH]: {
        'selectFeaturePanel.tab.asset': 'Asset details',
        'selectFeaturePanel.tab.assetOwner': 'Owner details',
        'selectFeaturePanel.tab.supplementaryData': 'Supplementary data',
        'selectFeaturePanel.tab.contactDetails': 'Contact details',
        'selectFeaturePanel.tab.specialMeasure': 'Special measure:',
        'selectFeaturePanel.tab.outOfDate': 'This feature is out of date compared to its expected refresh frequency',
        'selectFeaturePanel.tab.outOfDate.description': 'It is recommended that you contact the asset owner to verify the accuracy of the data before proceeding with any works.',
        'selectFeaturePanel.dataRefresh.outOfDate': '{days, plural, one {# day over data refresh date} other {# days over data refresh date}}',
        'selectFeaturePanel.dataRefresh.inDate': 'Data within expected refresh date',
        'selectFeaturePanel.dataRefresh.lessThanOneDayOverdue': 'Less than 1 day over refresh date'
    },
    [LOCALES.WELSH]: {
        'selectFeaturePanel.tab.asset': '[Asset details]',
        'selectFeaturePanel.tab.assetOwner': '[Owner details]',
        'selectFeaturePanel.tab.supplementaryData': 'Data atodol',
        'selectFeaturePanel.tab.contactDetails': '[Contact details]',
        'selectFeaturePanel.tab.specialMeasure': 'Mesur arbennig:',
        'selectFeaturePanel.tab.outOfDate': '[This feature is out of date compared to its expected refresh frequency]',
        'selectFeaturePanel.tab.outOfDate.description': 'Argymhellir eich bod yn cysylltu â pherchennog yr ased i gadarnhau cywirdeb y data cyn bwrw ymlaen ag unrhyw waith.',
        'selectFeaturePanel.dataRefresh.outOfDate': '[{days, plural, one {# day over data refresh date} other {# days over data refresh date}}]',
        'selectFeaturePanel.dataRefresh.inDate': '[Data within expected refresh date]',
        'selectFeaturePanel.dataRefresh.lessThanOneDayOverdue': '[Less than 1 day over refresh date]'
    }
};
